
export default {
  props: {
    /**
     * Where should this banner be located.
     *
     * @values bar, fixed, inline, float
     */
    type: {
      type: String,
      validator: value => ['bar', 'fixed', 'inline', 'float'].includes(value),
      default: 'bar'
    },

    /**
     * Removes the close button.
     */
    persistent: {
      type: Boolean,
      default: false
    },

    /**
     * The background color of this banner
     * @values colors
     */
    color: {
      type: String,
      default: 'primary-lighter'
    },

    /**
     * Which icon to show before the content.
     *
     * @values icons
     */
    icon: {
      /** @type {AlturaIcons} */
      type: String,
      default: undefined
    },

    /**
     * Not required, if specified toggles the visibility of the banner.
     * Supports .sync modifier.
     */
    show: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      internalShow: this.show
    };
  },

  computed: {
    transition () {
      const transitions = {
        bar: 'fade-up',
        fixed: 'fade-up',
        inline: 'fade',
        float: 'fade-down'
      };

      return transitions[this.type];
    }
  },

  watch: {
    show () {
      this.internalShow = this.show;
    }
  },

  methods: {
    remove () {
      if (!('close' in this.$listeners || 'update:show' in this.$listeners || this.show !== undefined)) {
        this.$destroy();
        this.$el.remove();
      }
    },

    close () {
      this.$emit('close');
      this.$emit('update:show', false);
      this.internalShow = false;
    }
  }
};
